export default "__VITE_ASSET__afD$DRL2__"